@if (show$ | async) {
  <button
    mat-icon-button
    [helpTooltip]="tip$ | async"
    [matTooltipPosition]="position"
    [matTooltipShowDelay]="300"
    [subject]="subject$ | async"
    [status]="status$ | async"
    [canEdit]="canEdit$ | async"
    (click)="openArticle($event)"
  >
    <mat-icon class="zef-icon-small" [color]="color$ | async">help_center</mat-icon>
  </button>
}
